export const OWASP_2025_CATEGORIES = [
  { id: 'A01', name: 'Broken Access Control', description: 'Access control enforcement and detection.' },
  { id: 'A02', name: 'Cryptographic Failures', description: 'Transport and crypto posture signals.' },
  { id: 'A03', name: 'Injection', description: 'Input handling and injection signals.' },
  { id: 'A04', name: 'Insecure Design', description: 'Design safeguards and guardrails.' },
  { id: 'A05', name: 'Security Misconfiguration', description: 'Configuration hygiene and exposure.' },
  { id: 'A06', name: 'Vulnerable and Outdated Components', description: 'Core/plugin update posture.' },
  { id: 'A07', name: 'Identification and Authentication Failures', description: 'Auth hardening and login safety.' },
  { id: 'A08', name: 'Software and Data Integrity Failures', description: 'Integrity checks and update trust.' },
  { id: 'A09', name: 'Security Logging and Monitoring Failures', description: 'Telemetry and alerting readiness.' },
  { id: 'A10', name: 'Server-Side Request Forgery', description: 'Outbound request controls.' },
];

export type OwaspStatus = 'ok' | 'warn' | 'critical' | 'resolved' | 'planned';

export const normalizeOwaspStatus = (value?: string | null): OwaspStatus => {
  const normalized = (value || '').toLowerCase();
  if (normalized === 'critical') return 'critical';
  if (normalized === 'warn' || normalized === 'warning') return 'warn';
  if (normalized === 'resolved') return 'resolved';
  if (normalized === 'planned' || normalized === 'not_implemented') return 'planned';
  return 'ok';
};
